module.exports = __webpack_public_path__ + "static/media/logo.be7f735c.png";